import { CFormTextarea } from '@coreui/react'
import React from 'react'

const Graytextarea = (props) => {
  
  const userData = JSON.parse(localStorage.getItem('user'))

 
  const role = userData?.Role
 
  return (
    <CFormTextarea
      className={`ui-form-textarea ${props?.className || ''}`.trim()}
      aria-rowcount={10}
      disabled={props?.disabled || false}
      style={{
        ...props?.style,
        height: props?.style?.height || props?.height || '300px',
        border: '1px solid rgb(113, 113, 113)',
        borderRadius: '8px',
        color: role == 'provider' ? 'var(--ui-text-primary, inherit)' : 'var(--ui-text-primary, inherit)',
        background: 'transparent',
        backgroundColor: 'transparent',
      }}
      {...props}
    />
  )
}

export default Graytextarea
